export class RenderCheckList {
    #booleanCheckList;
    #onRenderComplete = null;

    constructor(checkNames = []) {
        this.#booleanCheckList = new Map();

        if (Array.isArray(checkNames)) {
            // Case: passed an array
            for (let i of checkNames) {
                this.addCheck(i);
            }
        } else if (typeof checkNames === "string") {
            // Case: passed a single string
            this.addCheck(checkNames);
        } else if (arguments.length > 1) {
            // Case: passed multiple strings (spread)
            for (let i of arguments) {
                this.addCheck(i);
            }
        } else if (checkNames !== undefined) {
            throw new TypeError("Constructor only accepts an array or strings");
        }
    }

    addCheck(checkName) {
        this.#booleanCheckList.set(checkName, false);
    }

    checkAll() {
        const checkEntries = this.#booleanCheckList.entries();

        let allChecked = true;

        for(const [key, value] of checkEntries) {
            if(value === false)
                allChecked = false;
        }

        if(allChecked)
            this.#onRenderComplete();
    }

    check(checkName) {
        if (this.#booleanCheckList.has(checkName)) {
            this.#booleanCheckList.set(checkName, true);
            this.checkAll();
        }
    }

    setOnRenderComplete(onRenderFunction) {
        if(onRenderFunction instanceof Function) {
            this.#onRenderComplete = onRenderFunction;
        } else {
            throw new TypeError("You need to assign a function!");
        }
    }
}